import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.prereleaseMode_1 = prereleaseMode;
        this.auth0ClientId_1 = auth0ClientId;
        this.auth0Domain_1 = auth0Domain;
        this.basename_1 = basename;
        this.expressEnv_1 = expressEnv;
        this.webpackPublicPath_1 = webpackPublicPath;
        this.websocketHost_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.prereleaseMode_1 + ', auth0ClientId=' + this.auth0ClientId_1 + ', auth0Domain=' + this.auth0Domain_1 + ', basename=' + this.basename_1 + ', expressEnv=' + this.expressEnv_1 + ', webpackPublicPath=' + this.webpackPublicPath_1 + ', websocketHost=' + this.websocketHost_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.prereleaseMode_1);
        result = imul(result, 31) + getStringHashCode(this.auth0ClientId_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.auth0Domain_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.basename_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.expressEnv_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.webpackPublicPath_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.websocketHost_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.prereleaseMode_1 === other.prereleaseMode_1))
          return false;
        if (!(this.auth0ClientId_1 === other.auth0ClientId_1))
          return false;
        if (!(this.auth0Domain_1 === other.auth0Domain_1))
          return false;
        if (!(this.basename_1 === other.basename_1))
          return false;
        if (!(this.expressEnv_1 === other.expressEnv_1))
          return false;
        if (!(this.webpackPublicPath_1 === other.webpackPublicPath_1))
          return false;
        if (!(this.websocketHost_1 === other.websocketHost_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
